import React, { useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { firstWordUpper } from './_utils';
import { useSelector } from 'umi';
import { commonDateDefault } from '../../utils/dateUtils';

// 筛选器路径
const FILTER_PATH = 'monetization/revenue/inGameRevenue';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const PcConsoleRevenueInGameBreakFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, isHaveFilterSave, setFilterLoading, path = FILTER_PATH, children, timeZone = 0 } = props;
  // const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const { seasonInfo } = useSelector((state: any) => 
    // 初始可能为undefied,在此加兜底
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] },
    })
  );
  // 设置inputList
  const [inputList] = useState([commonDateDefault(timeZone, seasonInfo)]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    filterConfirm?.({
      // filterValue: {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      // },
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    filterReset?.({
      // filterValue: {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      // },
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
    }, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    filterInit?.({
      // filterValue: {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      // },
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
    setFilterLoading(false);
  };

  // const handleChange = (key: string, value: any) => {
  //   if (key === 'rangeTime') {
  //     filterValueRef.current = {
  //       ...filterValueRef.current,
  //       [key]: {
  //         type: value.type,
  //         value: value.value,
  //       },
  //     };
  //   }
  // };


  return <Filter
    openSticky={openSticky}
    isHaveFilterSave={isHaveFilterSave}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={handleInit}
    onConfirm={handleConfirm}
    onReset={handleReset}
  // onChange={handleChange}
  >
    {children}
  </Filter>;
};

export default PcConsoleRevenueInGameBreakFilter;
